import api from "../../api/api";

const associateRequestOtp = (payload) => {
    return new Promise((resolve, reject)=>{
        api.post("auth/associate/requestOtp",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const associateVerifyOtp = (payload) => {
    return new Promise((resolve, reject)=>{
        api.post("auth/associate/verifyOtp",payload).then( (res)=>{
            if(!res.data.error && res.data.data !== undefined){
                //setupLocalStorage(res.data.data)
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const associateAuthServices = {
    associateRequestOtp,
    associateVerifyOtp
}

export default associateAuthServices;